import { PREVIEW_STUDIO_URL } from './routeUrls';

export const previewToolConst = {
  macroDescription: 'Configure macros (optional)',
  htmlDescription: 'Enter Creative HTML to test for errors and view a preview',
  testATag: 'View in Test-a-Tag',
  openInPreview: 'Open in Preview',
  creativeButtonLabel: 'View in Preview',
  simplePreviewHostname: `http://inmrktpreview.s3-website.us-east-2.amazonaws.com/`,
  simpleNewPreviewHostname: 'https://production-creative-preview.360platform.inmarket.com/',
  previewStudioUrl: PREVIEW_STUDIO_URL,
};

export default previewToolConst;
